// extracted by mini-css-extract-plugin
module.exports = {"root":"IconAlert_root__2E7xR","inner":"IconAlert_inner__2ZcY7"};